import { DownloadIcon } from '@chakra-ui/icons';
import {
    Avatar,
    Box,
    Button,
    Heading,
    Link,
    Skeleton,
    SkeletonCircle,
    Text
} from '@chakra-ui/react';
import CopyProfileButton from '../components/CopyProfileButton';
import { ReactComponent as LinkedInIcon } from '../resources/linkedin-logo.svg';
import { ViewType } from './Profile';

interface IHeaderAvatarProps {
    view?: ViewType;
    name?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    slug?: string;
    email?: string | null;
    photoURL?: string | null;
    loading: boolean;
    portfolioLink?: string;
    oneLinkDescription?: string;
    resumeLink?: string;
}

export default function HeaderAvatar(props: IHeaderAvatarProps) {
    const {
        view,
        loading,
        name,
        firstName,
        lastName,
        slug,
        email,
        photoURL,
        portfolioLink,
        oneLinkDescription,
        resumeLink
    } = props;
    let interviewLink = '';
    if (name && slug !== undefined && email !== undefined) {
        interviewLink = buildInterviewLink(name, slug);
    }
    return (
        <Box
            className="headerInfo"
            borderBottom="1px solid"
            borderLeft="1px solid"
            borderRight="1px solid"
            borderColor="midnight.50"
            borderBottomRadius={{ lg: 'xl' }}
            backgroundColor="white"
            p="24px"
            w="100%"
            mb="24px"
        >
            <Box h={{ base: '40px', lg: '75px' }}>
                <SkeletonCircle
                    height="140px"
                    width="140px"
                    style={{ transform: 'translate(0, -58%)' }}
                    isLoaded={!loading}
                >
                    <Avatar
                        backgroundColor="midnight.75"
                        border="8px solid white"
                        p="2"
                        src={photoURL ?? ''}
                        height="140px"
                        width="140px"
                    />
                </SkeletonCircle>
            </Box>

            <Skeleton isLoaded={!loading}>
                <Heading size="xl" className="profileName">
                    {!lastName || view !== ViewType.LoggedOut
                        ? name
                        : firstName + ' ' + lastName[0]}
                </Heading>
            </Skeleton>

            <Skeleton isLoaded={!loading}>
                <Text fontSize="l" mb="2">
                    {oneLinkDescription ?? ''}
                </Text>
            </Skeleton>

            {view === ViewType.Student ? <CopyProfileButton slug={slug} /> : null}

            <Box display="flex">
                {view !== ViewType.LoggedOut && resumeLink ? (
                    <Link href={resumeLink} width="100%" mr="5px">
                        <Button variant="primary" mt="2" fontSize={{ base: '16px' }}>
                            <DownloadIcon fill="white" />
                            <Text ml="1">Resume</Text>
                        </Button>
                    </Link>
                ) : null}
                {view !== ViewType.LoggedOut && portfolioLink ? (
                    <Link href={portfolioLink} width="100%">
                        <Button
                            variant="primary"
                            mt="2"
                            _hover={{
                                backgroundColor: '#004C98',
                                textDecoration: 'none'
                            }}
                        >
                            <LinkedInIcon fill="white" />
                            <Text ml="2">
                                {portfolioLink.includes('linkedin.com') ? 'LinkedIn' : 'Portfolio'}
                            </Text>
                        </Button>
                    </Link>
                ) : null}
            </Box>
        </Box>
    );
}

function buildInterviewLink(name: string, slug: string) {
    let url = 'https://go.oncehub.com/PathMatchMemberInterviews?';
    return (url +=
        'Name%20of%20PathMatch%20Member=' +
        name +
        '&Slug=' +
        slug +
        '&email=' +
        // Zapier email inbox for processing interview requests.
        'bfarskkz@robot.zapier.com');
}
